<template>
    <resource-booking-category v-if="oneCategory" :categoryId="oneCategory.id" :globalSiteSetting="globalSiteSetting" />
    <div v-else>
        <div class="title primary--text text-center my-4">{{$translate('Book appointment')}}</div>
        <resource-booking-category-list :link="categoryPage" :globalSiteSetting="globalSiteSetting" />
    </div>
</template>

<script>
import ResourceBookingCategory from './ResourceBookingCategory.vue'
import ResourceBookingCategoryList from './ResourceBookingCategoryList.vue'
export default {
    name: 'zoezi-resource-booking-start-page',

    zoezi: {
        title: 'Resource booking start page',
        icon: 'mdi-format-list-text',
        addon: 'ResourceBooking'
    },

    components: {
        ResourceBookingCategory,
        ResourceBookingCategoryList
    },

    props: {
        categoryPage: {
            title: 'Page with category',
            type: String,
            fulltype: 'page'
        },
        globalSiteSetting: {
            title: 'Filter by globally selected site',
            type: Boolean,
            default: true
        }
    },

    data: () => ({
    }),

    computed: {
        categories() {
            if (!this.$store.state.settings?.resourcebookingcategories) {
                return [];
            }

            return this.$store.state.settings?.resourcebookingcategories;
        },
        oneCategory() {
            return this.categories.length == 1 ? this.categories[0] : null;
        }
    }
}
</script>
